import React from 'react';
import Image from 'next/image';
import Link from 'next/link';
import MWSVG from '../common/svg';

type Props = {
    name: string;
    data: string;
    path: any;
    alt: string;
    title: string;
    width: number;
    height: number;
    link: any;
};
const CasestudyCarouselItem: React.FC<Props> = ({ name, data, path, alt, title, width, height, link }) => {
    return (
        <div className="lg:mx-3 md:mx-3 mx-0">
            <div className="card h-full rounded-10 case-study-slider dark:bg-[#3C456133] dark:border-[#ffffff33] dark:border dark:border-solid">
                <div className="card-body flex justify-between flex-wrap lg:gap-0 gap-3">
                    <div className="card-description flex flex-col justify-between lg:w-3/6 w-full gap-2.5">
                        <div>
                            <p className="card-title mb-2.5 fs-lg fw-700 text-textcolor dark:text-white">{name}</p>
                            <p className="card-text card-text-des fs-md fw-400">{data}</p>
                        </div>
                        <div>
                            <Link href={link} className="btn btn-outline-primary inline-flex">
                                Read Case Study
                                <MWSVG id="tabler-icon-right-arrow" svgClassName="ic-24 ml-2.5" />
                            </Link>
                        </div>
                    </div>
                    <div className="lg:w-3/6 w-full flex justify-center">
                        <Image
                            src={`${path}`}
                            width={width}
                            height={height}
                            alt={alt}
                            title={title}
                            className="img-fluid case-study-img"
                            loading="lazy"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CasestudyCarouselItem;
